import { styleOverrides } from "./styleOverrides";

const MuiButton = {
  styleOverrides,
};

export { MuiButton };
